export default __webpack_public_path__ + "static/media/leader_active.64e28d6f.svg";